import { Component, OnInit, ViewChild } from '@angular/core';
import { AppSingle } from '../../app-single';
import { ChartComponent } from 'angular2-chartjs';
import { DependentModel } from '../../models/dependent.model';
import { ActivatedRoute } from '@angular/router';
import { NutritionClassificationService } from '../../services/nutrition-classification.service';
import { NutritionClassificationModel } from '../../models/nutritionClassification.model';

@Component({
  selector: 'app-nutritional-group',
  templateUrl: './nutritional-group.component.html',
  styleUrls: ['./nutritional-group.component.less']
})
export class NutritionalGroupComponent extends AppSingle implements OnInit {

  @ViewChild(ChartComponent) chart: ChartComponent;

  [x: string]: any;
  dependents: DependentModel[] = new Array<DependentModel>();
  type = 'bar';
  daysOfResume = 30;
  noneValue = 0;
  datasetGeralPosition = 0;
  datasetDependentPosition = 1;

  data = {
    labels: ['0', '1', '2', '3', '4'],
    fakeLabels: ['Indefinido', 'Ruim', 'Regular', 'Bom', 'Ótimo'],
    datasets: [
      {
        label: 'Consumo Geral',
        data: [],
        backgroundColor: '#CCC'
      },
      {
        label: 'Consumo Dependente',
        data: [],
        backgroundColor: '#32008E'
      }
    ],
  };

  options: {

    scales: {
      xAxes: [{
          stacked: true
      }],
      yAxes: [{
          stacked: true
      }]
  }

  };

  constructor(route: ActivatedRoute, private nutritionClassificationService: NutritionClassificationService) {
      super(route);
  }

  private pushValueToGraph(datasetPosition: number, value: number) {
    this.data.datasets[datasetPosition].data.push(value);
  }

  private SetGeralValuesOnChart() {
    this.nutritionClassificationService.getAll(this.companyId, this.daysOfResume)
      .then((_nutritionClassification: NutritionClassificationModel[]) => {
        if (_nutritionClassification.length > 0) {
          const totalSales = this.getTotalSales(_nutritionClassification);

          this.setPercentToNutritionClassification(_nutritionClassification, totalSales);

          this.data.labels.forEach(label => {
            const index = this.data.labels.indexOf(label);
            const nutritionClassification = _nutritionClassification.find(
              group => group.ClassificacaoLabel === this.data.fakeLabels[index]
            );

            if (nutritionClassification !== null && nutritionClassification !== undefined) {
              this.pushValueToGraph(this.datasetGeralPosition, nutritionClassification.percent);
            } else {
              this.pushValueToGraph(this.datasetGeralPosition, this.noneValue);
            }

          });
          this.chart.chart.update();
        }
      });
  }

  private getTotalSales(ratings: Array<NutritionClassificationModel>) {
    let total = 0;
    ratings.forEach(nutritionClassification => {
      total += nutritionClassification.Quantidade;
    });

    return <number>total;
  }

  private getPercent(value: number, totalSales: number) {
    return Number(((value * 100) / totalSales).toFixed(2));
  }

  private setPercentToNutritionClassification(ratings: Array<NutritionClassificationModel>, totalSales: number) {
    ratings.forEach(nutritionClassification => {
      nutritionClassification.percent = this.getPercent(nutritionClassification.Quantidade, totalSales);
    });

    return ratings;
  }

  private SetDependentValuesOnChart() {
    this.nutritionClassificationService.get(this.id, this.daysOfResume)
      .then((_nutritionClassification: NutritionClassificationModel[]) => {
        if (_nutritionClassification.length > 0) {
          const totalSales: number = this.getTotalSales(_nutritionClassification);

          this.setPercentToNutritionClassification(_nutritionClassification, totalSales);

          this.data.labels.forEach(label => {
            const index = this.data.labels.indexOf(label);
            const nutritionClassification = _nutritionClassification.find(
              group => group.ClassificacaoLabel === this.data.fakeLabels[index]
            );

            if (nutritionClassification !== null && nutritionClassification !== undefined) {
              this.pushValueToGraph(this.datasetDependentPosition, nutritionClassification.percent);
            } else {
              this.pushValueToGraph(this.datasetDependentPosition, this.noneValue);
            }

          });
          this.chart.chart.update();
        }
      });
  }

  ngOnInit() {
    this.SetGeralValuesOnChart();
    this.SetDependentValuesOnChart();

  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/nutritional-group/nutritional-group.component.ts